// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Currency from "../../../../../../../../library/data-source/country-currency/Currency.bs.js";
import * as Row$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/layout-components/Row.bs.js";
import * as CountryConfig from "../../../../../../../../library/data-source/country-config/app/entity/CountryConfig.bs.js";
import * as CountryContext from "../../../../../../../../library/data-source/country-config/context/CountryContext.bs.js";
import * as LabelUnit$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/label-unit/LabelUnit.bs.js";
import * as CorePricingViewUtils from "../../../library/utils/CorePricingViewUtils.bs.js";
import * as CardComponent$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/cards/CardComponent.bs.js";

function ModificationBaseDetailsCard(Props) {
  var base_details = Props.base_details;
  var free_km_price_per_min = base_details.free_km_price_per_min;
  var free_kms = base_details.free_kms;
  var waiting_rate = base_details.waiting_rate;
  var free_duration = base_details.free_duration;
  var base_fare = base_details.base_fare;
  var match = CountryContext.useContext(undefined);
  var currency = CountryConfig.getSymbol(match.country);
  return React.createElement(CardComponent$Catalyst.make, {
              className: "c-base-details-primary-info-card",
              children: null
            }, React.createElement(Row$Catalyst.make, {
                  children: null
                }, React.createElement(LabelUnit$Catalyst.make, {
                      label: "Base Fare",
                      unit: currency
                    }), React.createElement(Row$Catalyst.make, {
                      children: null
                    }, Currency.toCurrencyString(base_fare.value, currency), CorePricingViewUtils.getFloatDelta(base_fare.delta))), React.createElement("hr", {
                  className: "separator"
                }), React.createElement(Row$Catalyst.make, {
                  children: null
                }, React.createElement(LabelUnit$Catalyst.make, {
                      label: "Free Duration",
                      unit: "min"
                    }), React.createElement(Row$Catalyst.make, {
                      children: null
                    }, String(free_duration.value) + " mins", CorePricingViewUtils.getIntDelta(free_duration.delta))), React.createElement(Row$Catalyst.make, {
                  children: null
                }, React.createElement(LabelUnit$Catalyst.make, {
                      label: "Waiting Rate per min",
                      unit: currency + "/min"
                    }), React.createElement(Row$Catalyst.make, {
                      children: null
                    }, Currency.toCurrencyString(waiting_rate.value, currency), CorePricingViewUtils.getFloatDelta(waiting_rate.delta))), React.createElement("hr", {
                  className: "separator"
                }), React.createElement(Row$Catalyst.make, {
                  children: null
                }, React.createElement(LabelUnit$Catalyst.make, {
                      label: "Free KMs",
                      unit: "kms"
                    }), React.createElement(Row$Catalyst.make, {
                      children: null
                    }, String(free_kms.value) + " KMs", CorePricingViewUtils.getIntDelta(free_kms.delta))), React.createElement(Row$Catalyst.make, {
                  children: null
                }, React.createElement(LabelUnit$Catalyst.make, {
                      label: "Price per min for free KMs",
                      unit: currency + "/min"
                    }), React.createElement(Row$Catalyst.make, {
                      children: null
                    }, Currency.toCurrencyString(free_km_price_per_min.value, currency), CorePricingViewUtils.getFloatDelta(free_km_price_per_min.delta))));
}

var make = ModificationBaseDetailsCard;

export {
  make ,
  
}
/* react Not a pure module */
